import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/sustainability/community/client/CommunityClient.tsx");
